import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Checkbox, FormControlLabel} from '@mui/material'
import {Formik, useFormik} from 'formik'
import * as yup from 'yup'
import CpsSnackbar from 'shared/Snackbar'
import Input from './Input'
import {userInfoValidationSchema} from 'features/LoginNew/login.utils'
import GradientButton from 'shared/GradientButton'
import {Link} from 'react-router-dom'
import {fetchEmailId, toggleLoginPopup} from 'features/Login/login.slice'
import {type AppDispatch} from 'redux/store'
import {storePublicFunctionInput} from 'features/Registration/registration.slice'
import {ENDPOINT} from 'config/path'

const LoginForm = (props: any) => {
    const {handleLoginSubmit} = props
    const isLoading: boolean = useSelector((state: any) => state.login.isLoading)
    const resetPasswordIsLoading: boolean = useSelector((state: any) => state.resetPassword.isLoading)
    const resetPassword = useSelector((state: any) => state.resetPassword)
    const login = useSelector((state: any) => state.login)
    // eslint-disable-next-line
    // const [validations, setValidations] = useState({})
    const [snackbarMsg, setSnackbarMsg] = useState('')
    const [userIDFocused, setUserIDFocused] = useState(false)
    const [buttonError, setButtonError] = useState(true)
    const viewSchedulesValues = useSelector((state: any) => state.viewSchedules.initialValues)
    const trackShipmentValues = useSelector((state: any) => state.trackShipment.initialValues)
    const flightStatusValues = useSelector((state: any) => state.flightStatus.initialValues)
    const getStoredUserId = localStorage.getItem('userId')
    const dispatch = useDispatch<AppDispatch>()
    const initialValues: any = {
        userID: getStoredUserId ?? '',
        password: '',
        remember: '',
        isLogin: true
    }
    const formik = useFormik({
        initialValues,
        validationSchema: yup.object(userInfoValidationSchema),
        onSubmit: (values) => {
            handleLoginSubmit(values)
        }
    })

    useEffect(() => {
        setTimeout(() => {
            setUserIDFocused(true)
        }, 500)
    }, [])

    const _handleRememberIdChange = (e) => {
        if (e.target.checked) {
            localStorage.setItem('userId', formik.values.userID)
        } else {
            localStorage.removeItem('userId')
        }
    }
    const handleForgotPasswordClick = () => {
        // localStorage.setItem('storedEmail', formik.values.userID)
        dispatch(toggleLoginPopup(false))
        dispatch(fetchEmailId(formik.values.userID))
    }

    // useEffect(() => {
    //     const validationSchema = () => {
    //         const validation = userInfoValidationSchema
    //         setValidations(yup.object(validation))
    //     }
    //     validationSchema()
    // }, [])

    useEffect(() => {
        if (login?.error || login?.duplicate || resetPassword.error) {
            formik.resetForm(initialValues)
        }
    }, [login.error, login?.duplicate, resetPassword?.error])

    useEffect(() => {
        if (formik?.values?.userID !== '' && formik?.values?.password !== '') {
            setButtonError(false)
        } else {
            setButtonError(true)
        }
    }, [formik?.values?.userID, formik?.values?.password])

    const disableSubmitButton = buttonError || !formik?.isValid

    const userIdInfoModalContent = (
        <div className='user-id-info-content'>
            <p>Depending on when you registered, you may login with:</p>
            <ul>
                <li>a unique 6-32 character User ID that you created,</li>
                <li>or the business email address that you provided.</li>
            </ul>
        </div>
    )

    const publicFunctionRedirectionInfo = () => {
        dispatch(toggleLoginPopup(false))
        let publicFunctionInfo = {}
        if (
            viewSchedulesValues?.carrier !== '-Select-' &&
            viewSchedulesValues?.from?.code?.length > 0 &&
            viewSchedulesValues?.to?.code?.length > 0
        ) {
            publicFunctionInfo = {data: viewSchedulesValues, redirectUrl: ENDPOINT.viewSchedule}
        } else if (
            trackShipmentValues?.carrier !== '-Select-' &&
            trackShipmentValues?.airlineCode?.length > 0 &&
            trackShipmentValues?.airWayBill?.length > 0
        ) {
            publicFunctionInfo = {data: trackShipmentValues, redirectUrl: ENDPOINT.trackShipment}
        } else if (flightStatusValues?.carrier !== '-Select-' && flightStatusValues?.flightNo?.length > 0) {
            publicFunctionInfo = {data: flightStatusValues, redirectUrl: ENDPOINT.viewFlightStatus}
        }
        dispatch(storePublicFunctionInput(publicFunctionInfo))
    }

    // eslint-disable-next-line

    return (
        <Formik initialValues={formik.initialValues} onSubmit={() => {}} validate={() => ({})}>
            {userIDFocused && (
                <div className='loginFormInner'>
                    <form onSubmit={formik.handleSubmit}>
                        <Input
                            id='userID'
                            label='User ID or Business Email'
                            formik={formik}
                            // placeholder='name@example.com'
                            autoFocus={true}
                            inputInfoVisible={true}
                            showInputInfo={{
                                type: 'modal',
                                title: 'User ID or Business Email',
                                content: userIdInfoModalContent,
                                isClosable: true
                            }}
                        />
                        <Input
                            id='password'
                            label='Password'
                            formik={formik}
                            type='password'
                            showStrength={false}
                            autoFocus={false}
                        />
                        <GradientButton
                            isLoading={isLoading || resetPasswordIsLoading}
                            disabled={disableSubmitButton}
                            text='Log in'
                        />
                        <div className='formAdditionalElements'>
                            <FormControlLabel
                                className='formik__checkbox'
                                control={<Checkbox checked={formik.values.aggrement} />}
                                label={
                                    <React.Fragment>
                                        <span>Remember ID</span>
                                    </React.Fragment>
                                }
                                name='aggrement'
                                id='aggrement'
                                onChange={_handleRememberIdChange}
                                disabled={formik.values.userID === ''}
                            />
                            <span className='forgotPasswordLink'>
                                <Link to='/forgotpassword' onClick={handleForgotPasswordClick}>
                                    Forgot Password
                                </Link>
                            </span>
                        </div>
                        <div className='orSeparator'></div>
                        <div className='registerLink'>
                            <Link to='/register' onClick={publicFunctionRedirectionInfo}>
                                Register as Guest
                            </Link>
                        </div>
                    </form>
                    <CpsSnackbar msg={snackbarMsg} setMsg={setSnackbarMsg} />
                </div>
            )}
        </Formik>
    )
}

export default LoginForm
